import { PurchasesEntitlementInfos } from '@inkitt/contracts-common';
import { dynamicPaywallOffer, dynamicPaywallOfferData } from '@inkitt/types-galatea';
import { z } from 'zod';

// Backend  Only Response
export const getNewOfferResponse = z
  .object({
    noOfferReason: z.string(),
  })
  .or(
    z.object({
      offer: dynamicPaywallOffer,
    }),
  );
export type GetNewOfferResponse = z.infer<typeof getNewOfferResponse>;

// Client Response with Offer
export const dynamicOfferResponseWithOffer = z.object({
  offer: z.object({
    data: dynamicPaywallOfferData,
    expiresAt: z.number(),
    appliedAt: z.number(),
    offer_id: z.string(),
  }),
});
export type DynamicOfferResponseWithOffer = z.infer<typeof dynamicOfferResponseWithOffer>;

// Client Response without Offer
export const dynamicOfferResponseWithoutOffer = z.object({
  noOfferReason: z.string(),
});
export type DynamicOfferResponseWithoutOffer = z.infer<typeof dynamicOfferResponseWithoutOffer>;

// Client Response
export const getDynamicOfferResponse = dynamicOfferResponseWithoutOffer.or(dynamicOfferResponseWithOffer);
export type GetDynamicOfferResponse = z.infer<typeof getDynamicOfferResponse>;

export const getDynamicPaywallOfferBodyParams = z.object({
  hasActiveUnlimitedSubscription: z.string().or(z.boolean()),
  userCreatedAt: z.string(),
  revcatEntitlements: PurchasesEntitlementInfos.optional(),
  testDynamicPaywallVariantOverride: z.string().optional(),
  testDynamicPaywallV2Override: z
    .object({
      variantName: z.string(),
      payload: z.array(dynamicPaywallOffer),
    })
    .optional(),
  chaptersReadFirstHour: z.number().optional(),
  /**
   * Signal from the client that the user is on a `testPricingV4` variant which
   * enables golden-hour. When true, Saturn issues the offer defined by the
   * `featureGoldenHour` Unleash feature toggle.
   */
  isGoldenHourAvailable: z.boolean().optional(),
});

export type GetDynamicPaywallOfferBodyParams = z.infer<typeof getDynamicPaywallOfferBodyParams>;
